import { gql } from '../../../../../hooks'

export const GET_COMPONENT_INFO = gql`
  query ComponentInfo($id_component: ID!) {
    t1ComponentInfo(id: $id_component) {
    }
  }
`
